import { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { Password } from 'primereact/password';
import axios from 'axios';
import { useNavigate } from 'react-router';
import i18n from 'i18next';
import { useAuth } from '../../_common/AuthContext';
import { useSearchParams } from 'react-router-dom';

export default function Authentication() {
    const navigate = useNavigate();
    const {auth,setAuth, updateAuth,clearAuth} = useAuth();
    const [isSuccess, setIsSuccess] = useState(false)
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
    
    useEffect(() => {
        axios.get('/BBAuthentication/Authentication')
            .then(response => {
                const data =  response.data
                if(data.RedirectPage){
                    navigate(data.RedirectPage)
                }else{
                    setAuth(data)
                }
            })
            .catch(error => {
                console.error(error);
            });
    }, []);
    
    const handleSubmit = async (e) => {
        if (e) {
            e.preventDefault();
        }
        setErrorMessage('');

        if (!auth.Password) {
            setErrorMessage(i18n.t('auth.password_required'));
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post('/BBAuthentication/Authentication', auth);
            const data = response.data;
            if (data.IsAuthenticated) {
                if(data.IsSuccess){
                    clearAuth();
                    setIsSuccess(data.IsSuccess);
                    window.location.href = data.ReturnUrl;
                }else
                if (data.RedirectPage){
                    navigate(data.RedirectPage);
                }
            }else if (data.IsResetPwd){
                window.location.href = data.ReturnUrl;
            } else {
                setErrorMessage(data.ErrorMessage);
            }
        } catch (err) {
            setErrorMessage(i18n.t('auth.something_wrong'));
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e, field) => {
        const value = e.target.value;
        const updatedAuth = { ...auth, [field]: value };
        updateAuth(updatedAuth)
    };

    return (
        <div className="login-inner">
            <div className="body-inner">
                {!isSuccess && (
                    <form className="login-form" onSubmit={handleSubmit}>
                        {!auth.IsInvitation && (
                            <a id="btnBack" className="cursor-pointer flex align-items-center" type="button" onClick={() => navigate(-1)}>
                                <i className="pi pi-arrow-left mr-2" style={{ fontSize: '1.2rem' }}></i>
                                <p style={{ fontSize: '17px' }}>{auth.UserFullname}</p>
                            </a>
                        )}

                        <h4 className="mb-3 font-bold">{i18n.t('auth.enter_password')}</h4>

                        <div className="mb-3">
                            <Password id="password" value={auth.Password || ''} onChange={(e) => handleInputChange(e, 'Password')} autoFocus
                                feedback={false} inputClassName='w-full' className={classNames('w-full', { 'p-invalid': !!errorMessage })} placeholder={i18n.t('auth.password')}
                            />
                            {errorMessage && <small className="p-error" id="password-help">{errorMessage}</small>}
                        </div>
                        <div className="grid">
                            <div className="col-6" style={{ marginTop: "8px" }}>
                                <a href="authentication/forgotPwd" target={auth.IsClientAuthentication ? "_blank" : "_self"} className='text-primary'>{i18n.t('auth.forgot_password')}</a>
                            </div>
                                
                            <div className="col-6">
                                <Button type="submit" className='w-full' label={i18n.t('auth.login')} loading={loading} disabled={loading} />
                            </div>
                        </div>
                    </form>
                )}
                {isSuccess && (
                    <div className='login-form'>
                        <div className="text-2xl font-bold text-center">
                            {i18n.t('auth.auth_successfully')}
                        </div>
                        <div className="text-center" style={{marginTop: '10px'}}>
                            {i18n.t('auth.auth_redirecting')}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
